/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, computed, forwardRef, input, output } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-text-input',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TextInputComponent),
    },
  ],
})
export class TextInputComponent implements ControlValueAccessor {
  readonly placeHolder = input('');
  readonly label = input<string | undefined>();
  readonly name = input.required<string>();

  touched = false;
  disabled = false;
  value: string | undefined;

  onChange: (value: any) => void = () => {};
  onTouched = () => {};
  onFocus = output<void>();

  private readonly viewModel = computed(() => ({
    label: this.label(),
    name: this.name(),
    placeHolder: this.placeHolder(),
  }));

  get vm() {
    return this.viewModel();
  }

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  updateValue(value: string) {
    this.value = value;
    this.onChange(value);
    this.markAsTouched();
  }
}
